

import { LuMenu } from "react-icons/lu";
import { useApp } from "contexts/app";
import { Layout, Menu, theme, Button } from 'antd';
import { MenuOutlined } from "@ant-design/icons"
const { Header, Content, Footer, Sider } = Layout;
export default function AppHeader() {
    const { showMenu, setShowMenu } = useApp()
    return (


        <div>
            <Button type="link" onClick={e => setShowMenu(true)}>
                <MenuOutlined />
            </Button>
            <b>
                Thuỷ Tiên Food
            </b>

        </div>




    );
}